/**
 * Routes: /adressen/ and below
 *
 */

import AdressenList from '@/views/auth/adressen/AdressenList.vue'
import AdressenForm from '@/views/auth/adressen/AdressenFormPanel.vue'

export default [
    {
        path: '/adressen',
        name: 'adressen',
        component: AdressenList,
        meta: {
            requiresAuth: true,
            title: 'Adressen',
        },
        children: [
            {
                path: ':id',
                name: 'adresse',
                component: AdressenForm,
                meta: {
                    requiresAuth: true,
                    title: (to: { params: { id: number | string } }) => `Adresse: ${to.params.id}`,
                },
            },
        ],
    },
]
